import React, { useEffect, useState } from "react";
import { IoMdShareAlt } from "react-icons/io";
import { AiFillStar, AiOutlineEdit, AiOutlineStar } from "react-icons/ai";
import { CiLocationOn } from "react-icons/ci";
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "../../components/slider/slider.css";
import Textarea from "@mui/joy/Textarea";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { server } from "../../common";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { Button } from "@mui/material";
import { useSelectAccess } from "../../store/stateFunctions";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { useFormik } from "formik";
import { AxiosError } from "axios";

const AdminOrg_Details = () => {
  document.title = "Organization";
  const user = useSelectAccess("Student");
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedRating, setSelectedRating] = useState(0);

  // Define initialValues and useFormik outside of conditional blocks
  const initialValues = {
    comment: "",
  };

  const { values, handleChange, handleSubmit, resetForm } = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      comment: Yup.string().required("Please Enter comment"),
    }),

    onSubmit: (values, action) => {
      console.log(values);
      server
        .post(`/adminorganization/giveadmrating/${id}`, values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: user.authToken,
          },
        })
        .then(function (response) {
          console.log("api response", response.data);
          if (response.status === 200 || response.status === 201) {
            if (response.data) {
              toast.success("Comment shared");
              handleCloseModal();
              resetForm();
            }
          }
        })
        .catch(function (error) {
          if (error instanceof AxiosError && error.response?.data?.message)
            toast.error(error.response.data.message);
          else {
            toast.error(error.response.data.error);
          }
        });
    },
  });

  const isLoggedIn = user && user;
  const navigate = useNavigate();

  // Close modal
  const handleCloseModal = () => {
    setShowModal(false);
  };

  // Open modal for confirmation
  const handleOpenModal = () => {
    if (isLoggedIn) {
      setShowModal(true);
    } else {
      toast.info("Please log in to Add Your Comment");
      navigate("/loginstudent"); // Assuming you have a "/login" route
    }
  };

  useEffect(() => {
    getData();
    if (selectedRating !== 0) {
      submitRating();
    }
  }, [selectedRating]);

  const submitRating = () => {
    server
      .post(
        `/adminorganization/giveadmrating/${id}`,
        {
          star: selectedRating,
        },
        {
          headers: {
            Authorization: user.authToken,
          },
        }
      )
      .then(function (response) {
        console.log("Rating submitted successfully:", response.data.message);
        toast.success("Rating Addded");
      })
      .catch(function (error) {
        console.error("Error submitting rating", error);
        toast.error(error.message);
      });
  };

  const getData = () => {
    server
      .get(`/adminorganization/getorg_details/${id}`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  if (!data) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <div
        className="container-xl my-4 bg-light border"
        style={{ marginTop: "5rem" }}
      >
        <div className="row ">
          <div className="col-md-5 p-4">
            <Swiper
              modules={[Navigation, Pagination, Autoplay, A11y]}
              slidesPerView={1}
              navigation
              pagination={{ clickable: true }}
              autoplay={{
                delay: 2000,
                pauseOnMouseEnter: true,
                disableOnInteraction: false,
              }}
              loop={true}
            >
              <SwiperSlide>
                <img
                  className="w-100 img-fluid rounded-4"
                  src={data.image}
                  alt=""
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  className="w-100 img-fluid rounded-4"
                  src={data.image}
                  alt=""
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  className="w-100 img-fluid rounded-4"
                  src={data.image}
                  alt=""
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  className="w-100 img-fluid rounded-4"
                  src={data.image}
                  alt=""
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  className="w-100 img-fluid rounded-4"
                  src={data.image}
                  alt=""
                />
              </SwiperSlide>
            </Swiper>
          </div>
          <div className="col-md-6 mt-5">
            <h3>{data.business_name}</h3>
            <p>{data.details}</p>
            <div className="d-flex">
              <div>
                <a
                  href="tel:+9371001138 "
                  className="text-decoration-none text-white btn banner text-white me-3"
                >
                  Call
                </a>
              </div>
              <div className="">
                <a
                  className="text-white text-decoration-none btn banner  me-3"
                  href={data.location}
                  target="_blank"
                >
                  Get Direction
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="row shadow">
          <div className="col-md-7  mt-3 p-3">
            <h3 className="text-uppercase">Quick Information</h3>
            <div className="text-uppercase ">
              <p>
                Contact: &nbsp;
                <b>{data.mobile}</b>
                <br />
              </p>
              <p>
                Email-Id: &nbsp;
                <a href="mailto:theinnovativesolutions@gmail.com">
                  {data.email}
                </a>
              </p>
              <p>
                Website: &nbsp;
                <a href={data.url1} target="_blank">
                  {data.url1}
                </a>
              </p>
            </div>

            <div className="mt-3">
              <h3 className="text-uppercase">Timing</h3>
              <p>{data.timing}</p>
            </div>
            <div className="col-md-6 text-start">
              <div className="d-flex align-items-center">
                <div className="average-rating my-2">
                  {data.average_rating} &nbsp;
                </div>
                <div className="star-icons">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <AiFillStar
                      key={star}
                      className={
                        star <= data.average_rating
                          ? "filled-star text-warning"
                          : ""
                      }
                    />
                  ))}
                </div>
              </div>
              <div className="total-reviews">{data.total_ratings} reviews</div>
            </div>
          </div>

          <div className="col-md-5  mt-3 p-3">
            <h3 className="text-uppercase">Address</h3>
            <p>{data.address}</p>

            <p>
              Google Location :{" "}
              <a href={data.location} target="_blank">
                Go To location
              </a>
            </p>

            <p>
              <IoMdShareAlt className="fs-3" />
              Share
            </p>
            <hr />
            <p>
              {isLoggedIn ? (
                <>
                  {[1, 2, 3, 4, 5].map((index) => (
                    <AiFillStar
                      key={index}
                      className={`fs-3 ${
                        index <= selectedRating ? "text-warning" : "text-muted"
                      }`}
                      onClick={() => setSelectedRating(index)}
                    />
                  ))}
                </>
              ) : (
                <p>
                  Please <NavLink to="/loginstudent">login</NavLink> to add
                  ratings and comments.
                </p>
              )}
            </p>

            <p>
              <div>
                <button
                  className="banner text-white p-1 border-0 rounded-3"
                  onClick={() => handleOpenModal()}
                >
                  Add Comment
                </button>
              </div>
            </p>
            <hr />
          </div>
          <div className="p-5">
            <h5>Clients Comments :</h5>

            {/* {data.comments.map((item) => {
              return (
                <>
                  <p>- {item.comment}</p>
                </>
              );
            })} */}
          </div>
        </div>
      </div>

      {/* Modal for confirmation */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Please Share Your Comment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <Textarea
              minRows={4}
              name="comment"
              className="my-3"
              value={values.comment}
              onChange={handleChange}
              placeholder="Please Share Your Good Feedback For This Shop..."
            />
            <Modal.Footer>
              <Button variant="contained" onClick={handleCloseModal}>
                Cancel
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="success"
                className="ms-2"
              >
                Share
              </Button>
            </Modal.Footer>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AdminOrg_Details;
